// extracted by mini-css-extract-plugin
module.exports = {"content":"_c690482","documentsPreviewWrapper":"_824f2d6"};